"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Trigger = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 15,
  height: 16,
  viewBox: "0 0 15 16",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.105 15.71l4.352-4.358-.703-.704-3.649 3.641-1.398-1.39-.703.703 2.101 2.109z",
  fill: "#1973E8"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M10.895 7H6.543l3-6H6.16l-4 8h3.508l-3 6h.227l8-8z",
  fill: "#1973E8"
}), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.316 6l-10 10H1.051l3-6H.543l5-10h5.617l-3 6h5.156zM6.543 7h4.352l-8 8h-.227l3-6H2.16l4-8h3.383l-3 6z",
  fill: "#1973E8"
}));
var _default = exports.default = Trigger;